// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2CUyb","unreadBadge":"styles_unreadBadge__2GJ73","modalContent":"styles_modalContent__2XEZh","modal":"styles_modal__22aAA"};